// const fancyboxContainer = new PerfectSB($('.fancybox-slide'))
// const searchMainList = new PerfectSB('.modal__search-main-result-list')
// const citySearchList = new PerfectSB($('.modal__city-list'))

const fancyboxDefaultOptions = {
  touch: false,
  autoFocus: false,
  backFocus: false,
  // afterShow: function () {
  //   new PerfectSB($('.fancybox-slide')).init()

  //   if ($(this.src).find('.modal__city-list').length) {
  //     !!citySearchList.el ? citySearchList.update() : citySearchList.init()
  //   }

  //   setTimeout(() => {
  //     $(this.src + '.fancybox-content')
  //       .parent()
  //       .addClass('perfectScrollbar-init')
  //   }, 100)
  // },
  // afterClose: function () {
  //   $(this.src + '.fancybox-content')
  //     .parent()
  //     .removeClass('perfectScrollbar-init')

  //   if (this.src === '#city-select') {
  //     $('.modal__city-search .input-field__clear-button').trigger('click')
  //   }
  // },
}

$('[data-fancybox]').each((idx, item) => {
  if ($(item).attr('href') === '#product-card__image-view') {
    $(item).fancybox({
      ...fancyboxDefaultOptions,
      baseClass: 'is--fullscreen',
    })
  } else {
    $(item).fancybox(fancyboxDefaultOptions)
  }
})

// $('[data-fancybox]').fancybox(fancyboxDefaultOptions)

const openModalById = id => {
  $.fancybox.open({
    ...fancyboxDefaultOptions,
    src: id,
  })
}

const openRequestSuccessModal = data => {
  const src = $(`
    <div class="popup popup--status">
      <div class="popup__body popup__body--centered">
        <div class="popup__status-icon">
          <svg width="253" height="253" viewBox="0 0 253 253" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M187.77 113.42C187.765 111.493 188.522 109.641 189.876 108.27C191.231 106.898 193.073 106.118 195 106.1H195.06C196.485 106.1 197.878 106.524 199.06 107.32C200.405 104.995 202.478 103.178 204.96 102.15C207.442 101.123 210.194 100.943 212.788 101.638C215.383 102.333 217.676 103.864 219.312 105.994C220.949 108.124 221.837 110.734 221.84 113.42V114C224.264 114.88 226.303 116.583 227.599 118.813C228.895 121.043 229.366 123.658 228.93 126.2C228.494 128.742 227.178 131.05 225.213 132.721C223.249 134.391 220.759 135.318 218.18 135.34H190.18C188.518 135.343 186.882 134.921 185.429 134.114C183.976 133.307 182.753 132.141 181.878 130.727C181.003 129.314 180.504 127.7 180.429 126.039C180.354 124.379 180.706 122.727 181.45 121.24C182.109 119.904 183.059 118.732 184.23 117.81C185.394 116.897 186.77 116.295 188.23 116.06C187.926 115.213 187.771 114.32 187.77 113.42Z" fill="#F4F4F8"/>
          <path d="M159.61 37.19C159.606 36.4472 159.749 35.7109 160.029 35.0232C160.31 34.3356 160.724 33.7101 161.247 33.1825C161.77 32.6549 162.392 32.2357 163.077 31.9487C163.762 31.6617 164.497 31.5126 165.24 31.51C166.356 31.5 167.448 31.8315 168.37 32.46C169.206 31.0212 170.406 29.8279 171.85 29C173.3 28.1317 174.96 27.6785 176.65 27.69C179.158 27.7005 181.561 28.7016 183.335 30.4753C185.108 32.249 186.109 34.6516 186.12 37.16V37.64C187.594 38.1576 188.897 39.0691 189.89 40.2754C190.882 41.4817 191.525 42.9368 191.748 44.4827C191.972 46.0286 191.768 47.6062 191.158 49.0443C190.549 50.4824 189.557 51.7259 188.29 52.64C186.832 53.685 185.084 54.2479 183.29 54.25H161.49C160.495 54.25 159.51 54.0539 158.591 53.6728C157.672 53.2918 156.837 52.7333 156.134 52.0293C155.431 51.3253 154.873 50.4896 154.493 49.57C154.113 48.6504 153.919 47.6649 153.92 46.67C153.912 45.4988 154.187 44.3429 154.72 43.3C155.226 42.2591 155.965 41.3489 156.88 40.64C157.784 39.9197 158.859 39.4444 160 39.26C159.749 38.5984 159.617 37.8976 159.61 37.19Z" fill="#F4F4F8"/>
          <path d="M28.11 73.42C28.1034 71.8953 28.3972 70.3843 28.9746 68.9732C29.5519 67.5621 30.4016 66.2785 31.4751 65.1958C32.5485 64.1131 33.8247 63.2524 35.2308 62.6629C36.6369 62.0733 38.1453 61.7665 39.67 61.76H39.77C42.0632 61.7418 44.3083 62.4181 46.21 63.7C48.3566 60.0007 51.6616 57.1111 55.6145 55.4777C59.5674 53.8443 63.9481 53.558 68.08 54.6629C72.2118 55.7679 75.8649 58.2026 78.4748 61.591C81.0848 64.9794 82.5063 69.133 82.52 73.41V74.41C86.4243 75.775 89.7186 78.4795 91.8178 82.0433C93.917 85.607 94.6853 89.7994 93.9863 93.876C93.2873 97.9526 91.1662 101.649 87.9996 104.31C84.8331 106.971 80.826 108.424 76.69 108.41H32C29.9566 108.409 27.9335 108.005 26.0462 107.222C24.1588 106.439 22.4443 105.291 21.0003 103.846C19.5564 102.4 18.4113 100.684 17.6306 98.7953C16.8498 96.907 16.4486 94.8834 16.45 92.84C16.4474 90.4368 17.0091 88.0665 18.09 85.92C19.1423 83.7904 20.6556 81.9219 22.52 80.45C24.3567 79.0003 26.5312 78.0404 28.84 77.66C28.3586 76.2981 28.1117 74.8644 28.11 73.42Z" fill="#F4F4F8"/>
          <path d="M128.75 164.28C144.717 164.28 157.66 151.337 157.66 135.37C157.66 119.403 144.717 106.46 128.75 106.46C112.783 106.46 99.84 119.403 99.84 135.37C99.84 151.337 112.783 164.28 128.75 164.28Z" fill="white" stroke="#F4F4F8" stroke-width="2"/>
          <path d="M135.25 128.67L133.6 127L126.17 134.44L127.82 136.09L135.25 128.67ZM140.25 127.01L127.86 139.52L122.86 134.52L121.21 136.17L127.82 142.78L142 128.66L140.25 127.01ZM114.53 136.22L121.13 142.83L122.79 141.17L116.18 134.56L114.53 136.22Z" fill="#5EA9FF"/>
          <path d="M184 164.68C182.594 178.35 176.169 191.012 165.967 200.218C155.765 209.425 142.512 214.52 128.77 214.52" stroke="#1A1A1A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M73.23 104.83V80.83C73.0309 73.4163 74.3192 66.0378 77.0189 59.1302C79.7185 52.2226 83.7747 45.9258 88.948 40.6117C94.1214 35.2976 100.307 31.0739 107.14 28.1898C113.972 25.3058 121.314 23.8199 128.73 23.8199C136.146 23.8199 143.488 25.3058 150.32 28.1898C157.153 31.0739 163.339 35.2976 168.512 40.6117C173.685 45.9258 177.741 52.2226 180.441 59.1302C183.141 66.0378 184.429 73.4163 184.23 80.83V106.32" stroke="#1A1A1A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M81.43 106.17V163.54C78.5498 164.442 75.5482 164.898 72.53 164.89C68.2301 164.857 63.9876 163.899 60.0901 162.083C56.1926 160.266 52.7311 157.633 49.9403 154.362C47.1495 151.09 45.0945 147.257 43.9147 143.122C42.7349 138.987 42.4578 134.647 43.1022 130.395C43.7466 126.144 45.2974 122.08 47.6495 118.481C50.0017 114.881 53.1002 111.829 56.735 109.532C60.3699 107.234 64.4562 105.745 68.7169 105.165C72.9776 104.585 77.3133 104.928 81.43 106.17Z" fill="white" stroke="#5EA9FF" stroke-width="3" stroke-linejoin="round"/>
          <path d="M138.23 227.67H122.56C119.879 227.67 117.307 226.605 115.411 224.709C113.515 222.813 112.45 220.241 112.45 217.56V211.49C112.45 208.809 113.515 206.237 115.411 204.341C117.307 202.445 119.879 201.38 122.56 201.38H138.23C140.911 201.38 143.483 202.445 145.379 204.341C147.275 206.237 148.34 208.809 148.34 211.49V217.56C148.34 220.241 147.275 222.813 145.379 224.709C143.483 226.605 140.911 227.67 138.23 227.67Z" fill="white"/>
          <path d="M138.23 227.67H122.56C119.879 227.67 117.307 226.605 115.411 224.709C113.515 222.813 112.45 220.241 112.45 217.56V211.49C112.45 208.809 113.515 206.237 115.411 204.341C117.307 202.445 119.879 201.38 122.56 201.38H138.23C140.911 201.38 143.483 202.445 145.379 204.341C147.275 206.237 148.34 208.809 148.34 211.49V217.56C148.34 220.241 147.275 222.813 145.379 224.709C143.483 226.605 140.911 227.67 138.23 227.67" stroke="#1A1A1A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M171.57 163.54V106.18C174.45 105.278 177.452 104.822 180.47 104.83C188.434 104.83 196.073 107.994 201.704 113.626C207.336 119.257 210.5 126.896 210.5 134.86C210.5 142.824 207.336 150.463 201.704 156.094C196.073 161.726 188.434 164.89 180.47 164.89C177.452 164.898 174.45 164.442 171.57 163.54Z" fill="white" stroke="#5EA9FF" stroke-width="3" stroke-linejoin="round"/>
          </svg>
        </div>
        <b class="popup__subtitle">
          ${data && data.title ? data.title : 'Спасибо!'}
        </b>
        <p class="popup__desc">
          ${data && data.desc ? data.desc : 'В&nbsp;скором времени наш менеджер обязательно с&nbsp;вами свяжется.'}
        </p>
        <div class="popup__bottom">
          <button class="popup__close button button--fullwidth" data-fancybox-close="">
            Ок
          </button>
        </div>
      </div>
    </div>
  `)

  $.fancybox.open({
    ...fancyboxDefaultOptions,
    type: 'html',
    src: $('<div>').append(src).html(),
  })
}

// const openRequestFailurModal = data => {
//   const src = $(`
//     <div class="modal modal--status ${data && data.className ? data.className : ''}">
//       <div class="h5 modal__title ${data && data.header ? '' : 'is--hidden'}">
//         <button class="modal__title-close-button mobile-only" type="button" data-fancybox-close>
//           <svg>
//             <use xlink:href="${assetsPath}img/sprite.svg#arrow-right"></use>
//           </svg>
//         </button>

//         ${data && data.header ? '<span>' + data.header + '</span>' : ''}

//       </div>
//       <div class="modal__body modal__body--centered">
//         <div class="modal__status-icon modal__status-icon--fail">
//           <svg>
//             <use xlink:href="${assetsPath}img/sprite.svg#close"></use>
//           </svg>
//         </div>
//         <b class="modal__subtitle">
//           ${data && data.title ? data.title : 'Произошла ошибка!'}
//         </b>
//         <p class="modal__desc">
//           ${data && data.desc ? data.desc : ''}
//         </p>
//         <div class="modal__bottom">
//           <button class="modal__close button button--fullwidth" data-fancybox-close="">
//             Закрыть
//           </button>
//         </div>
//       </div>
//     </div>
//   `)

//   $.fancybox.open({
//     ...fancyboxDefaultOptions,
//     type: 'html',
//     src: $('<div>').append(src).html(),
//   })
// }

// const openCustomModal = data => {
//   const {className, header, title, desc} = {...data}
//   if (!header && !title && !desc) {
//     console.error('openCustomModal, требуется хотя бы один параметр: header, title, desc')
//     return
//   }

//   const src = $(`
//     <div class="modal modal--status ${className ? className : ''}">
//       <div class="h5 modal__title ${header ? '' : 'is--hidden'}">
//         <button class="modal__title-close-button mobile-only" type="button" data-fancybox-close>
//           <svg>
//             <use xlink:href="${assetsPath}img/sprite.svg#arrow-right"></use>
//           </svg>
//         </button>

//         ${header ? '<span>' + header + '</span>' : ''}

//       </div>
//       <div class="modal__body modal__body--centered">
//         <b class="modal__subtitle">
//           ${title ? title : ''}
//         </b>
//         <p class="modal__desc">
//           ${desc ? desc : ''}
//         </p>
//         <div class="modal__bottom">
//           <button class="modal__close button button--fullwidth" data-fancybox-close="">
//             Закрыть
//           </button>
//         </div>
//       </div>
//     </div>
//   `)

//   $.fancybox.open({
//     ...fancyboxDefaultOptions,
//     type: 'html',
//     src: $('<div>').append(src).html(),
//   })
// }

const openTemplateModal = (id, data) => {
  const $modal = $(id).clone()

  if (data) {
    Object.keys(data).forEach(key => {
      $modal.html($modal.html().replace(`#${key}#`, data[key]))
      // const $item = $modal.find(`:contains('#${key}#')`).last()

      // $item.html($item.html().replace(`#${key}#`, data[key]))
    })
  }

  $.fancybox.open({
    ...fancyboxDefaultOptions,
    type: 'html',
    src: $('<div>').append($modal).html(),
  })
}

const closeActiveModal = () => {
  $.fancybox.close()
}

const closeAllModals = () => {
  $.fancybox.close(true)
}
